import React, { useEffect, useState } from "react";
import { LiaLongArrowAltLeftSolid } from "react-icons/lia";
import { changeHeader } from "../../../redux/reducer/headerSlice";
import { useDispatch } from "react-redux";
import { AiOutlineEye } from "react-icons/ai";

import send from "../../../assests/icons/frame1.png";
import clip from "../../../assests/icons/clip.png";
import handleGet from "../../../utils/Get";
import handlePost from "../../../utils/Post";
import { BASE_URL } from "../../../utils/config";
import { useParams } from "react-router";
import { Button, Modal, Spin, Tooltip } from "antd";
import { Link } from "react-router-dom";

export default function () {
  const { id } = useParams();
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ticketData, setTicketData] = useState("");
  const [time, setTime] = useState(0);
  const [messageData, setMessageData] = useState({
    ticket_id: id,
    message: "",
  });
  const user = JSON.parse(localStorage.getItem("user"));

  const dispatch = useDispatch();
  useEffect(() => {
    handleFetchTiketDetails();
    dispatch(changeHeader(`${user.name}, Tickets`));
  }, []);

  const handleFetchMessage = async () => {
    const data = await handleGet(`${BASE_URL}ticket/message/get/${id}`);
    setMessage(data?.message_data);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleFetchMessage();
      setTime(40 * 1000);
    }, time);
    return () => {
      clearInterval(intervalId);
    };
  });

  const handlePostMessage = async () => {
    try {
      const response = await handlePost(
        `${BASE_URL}ticket/message/post`,
        messageData
      );
      if (response) {
        setMessageData({ message: "", ticket_id: id });
        handleFetchMessage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFetchTiketDetails = async () => {
    const data = await handleGet(`${BASE_URL}ticket/view/${id}`);
    console.log(data);
    setTicketData(data?.ticket);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return Array.isArray(message) ? (
    <main className="w-full h-full">
      {ticketData && (
        <Modal
          title=""
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <Button onClick={handleOk}>Ok</Button>
            </>
          )}
        >
          <p className="font-nunito text-2xl font-medium">Ticket Details</p>
          <p className="font-nunito text-lg font-medium mt-2">
            Title: {ticketData?.title}
          </p>
          <p className="font-nunito text-lg font-medium my-1">
            Detail: {ticketData?.detail}
          </p>
          <p className="font-nunito text-lg font-medium my-1">
            Status: {ticketData?.status ?? "Pending"}
          </p>
        </Modal>
      )}

      {/* ✅ FIX: flex-col layout so messages scroll and input sticks to bottom */}
      <section className="w-full bg-theme-white dark:bg-dark dark:border dark:border-[#334155] rounded-xl p-4 flex flex-col" style={{ height: "80vh" }}>
        
        {/* Header */}
        <div className="flex justify-between items-center mb-4 flex-shrink-0">
          <Link
            to="/user/support"
            className="w-10 h-9 bg-[#E6E8F0] dark:bg-dark-body dark:border dark:border-[#334155] flex justify-center cursor-pointer items-center rounded-lg"
          >
            <p className="dark:text-dark-text">
              <LiaLongArrowAltLeftSolid size={24} />
            </p>
          </Link>
          <div
            onClick={() => setIsModalOpen(true)}
            className="w-fit h-fit cursor-pointer px-3 py-2 bg-[#E6E8F0] dark:bg-dark-body dark:border dark:border-[#334155] rounded-lg flex gap-2 items-center"
          >
            <p className="dark:text-dark-text flex gap-2 items-center">
              <AiOutlineEye />
              <span className="font-nunito font-medium">Ticket Details</span>
            </p>
          </div>
        </div>

        {/* ✅ Messages area — scrollable, takes remaining height */}
        <div className="flex-1 overflow-y-auto mb-3 pr-1">
          {message?.length ? (
            message?.map(({ message, id, sender, time }) => {
              return (
                <div
                  key={id}
                  className={`w-full flex ${
                    sender?.id === user?.id ? "justify-end" : "justify-start"
                  }`}
                >
                  <div>
                    <div
                      className={`flex items-center ${
                        sender?.id === user?.id
                          ? "flex-row-reverse"
                          : "flex-row"
                      } gap-4`}
                    >
                      <Tooltip title={sender?.name || "User"}>
                        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-lg sm:text-xl flex-shrink-0">
                          {sender?.name?.charAt(0)?.toUpperCase() || "U"}
                        </div>
                      </Tooltip>

                      <div className="w-fit h-fit max-w-[200px] sm:max-w-[320px] break-all sm:min-w-[200px] md:min-w-[320px] min-h-[60px] bg-[#E6E8F0] dark:bg-dark-body dark:border dark:border-[#334155] dark:text-dark-text rounded-lg p-3 text-sm font-nunito flex items-center">
                        {message}
                      </div>
                    </div>
                    <div
                      className={`${
                        sender?.id === user?.id ? "text-end" : "text-start"
                      } text-xs text-gray-400 my-2 font-nunito`}
                    >
                      {new Date(time).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="font-nunito text-2xl dark:text-dark-text">
              NO CHATS
            </div>
          )}
        </div>

        {/* ✅ Input bar — fixed at bottom of flex container, always visible */}
        <div className="flex-shrink-0 flex items-center gap-2 border-t border-gray-200 dark:border-[#334155] pt-3">
          <input
            onKeyDown={(e) => e.key === "Enter" && handlePostMessage()}
            value={messageData?.message}
            onChange={(e) =>
              setMessageData({ ...messageData, message: e.target.value })
            }
            className="flex-1 min-w-0 h-10 px-3 border-none outline-none rounded-lg bg-[#E6E8F0] dark:bg-dark-body dark:text-dark-text text-sm font-nunito"
            type="text"
            placeholder="Hello, How we can help you?"
          />
          <div
            onClick={handlePostMessage}
            className="w-10 h-10 flex-shrink-0 rounded-full cursor-pointer bg-[#6c5dd3] flex justify-center items-center"
          >
            <img src={send} alt="send" className="w-7 h-7" />
          </div>
        </div>
      </section>
    </main>
  ) : (
    <div className="w-full h-[80vh] flex justify-center items-center">
      <Spin size="large" />
    </div>
  );
}